<template>
  <div class="container">
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2 class="mr-5">
          {{ $t('appointmentspage.title') }}
        </h2>
      </template>
      <template #end>
        <Button
          :label="$t('lineidpage.extractactivity')"
          icon="pi pi-download"
          class="p-button-rounded p-button-outlined col-12"
          @click="extract"
        />
      </template>
    </Toolbar>
    <div class="container">
      <div class="mb-3">
        <AgentCalendar @select-appointment="onSelectAppointment" />
      </div>
    </div>

    <AppointmentDetailDialog
      v-if="selectedAppointment"
      v-model:visible="showDialog"
      :appointment="selectedAppointment"
    />
  </div>
</template>

<script>
import '@fullcalendar/core/vdom'
import Toolbar from "primevue/toolbar";
import Button from "primevue/button";
import {convertDateStringToDayLocaleString, convertDateStringToTimeLocaleString} from "@/shared/utils/dateTimeUtils";
import moment from "moment";

import AgentCalendar from "@/components/appointments/AgentCalendar";
import AppointmentDetailDialog from "@/components/appointments/AppointmentDetailDialog";
import useControlFilter from "@/composables/filters/useControlFilter";
import {reactive} from "vue";

export default {
  name: 'AppointmentsView',
  components: {AppointmentDetailDialog, AgentCalendar, Toolbar, Button},
  setup(){
    const controlFilter = reactive(useControlFilter());
    controlFilter.pageable.size = 1;
    controlFilter.filters.deleted.value = false;
    return {
      controlFilter
    }
  },
  data() {
    return {
      codeError: '',
      code: null,
      showDialog: false,
      selectedAppointment: null,
    }
  },

  methods: {
    getAppointmentDay(dateString) {
      return convertDateStringToDayLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentStartTime(dateString) {
      return convertDateStringToTimeLocaleString(dateString, this.$i18n.locale)
    },
    getAppointmentEndTime(dateString) {
      const end = moment(dateString, 'HH:mm:ss').toDate()
      return convertDateStringToTimeLocaleString(end, this.$i18n.locale)
    },

    async onSelectAppointment(appointment) {
      this.selectedAppointment = appointment
      this.showDialog = true
    },

    async extract() {
      const kpi = await this.$exportService.kpi();

      const blob = new Blob([kpi], {type:'application/vnd.ms-excel'});
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      const localDate = new Date()
      const date = localDate.toLocaleDateString().replaceAll("/", "-");
      const time = localDate.toLocaleTimeString().replaceAll(":","-")
      link.download = `Activity_KPI_${date}_${time}.xlsx`;
      link.click();
    }
  }
}
</script>

